export class ReservationDetailDate {
    id: string;
    reservationDetailId: string;
    date: Date;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/reservation-detail-date.ts